import { render, staticRenderFns } from "./SBSignUpIcon.html?vue&type=template&id=7fa5950e&scoped=true&"
import script from "./SBSignUpIcon.ts?vue&type=script&lang=ts&"
export * from "./SBSignUpIcon.ts?vue&type=script&lang=ts&"
import style0 from "./SBSignUpIcon.css?vue&type=style&index=0&id=7fa5950e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5950e",
  null
  
)

export default component.exports